import React from 'react';

export const Store = React.createContext({});

function reducer(state: any, action: any) {
  switch (action.type) {
    /**
     * Store Funds
     */
    case "LOAD_DATA":
      return {
        ...state,
        tableResults: action.payload.hits.hits,
        tableTotal: action.payload.hits.total,
        loading: false,
        dataCompare: false
      };

    case "LOAD_SUBCATEGORIES":
      return {
        ...state,
        tableTaxo: action.payload.aggregations,
        dataCompare: false
      };
    case "CHANGE_CURRENT_PAGE":
      return {
        ...state,
        filterCurrentPage: action.payload,
        filterCurrentSize: (action.payload - 1) * 10
      };
    /**
     * Store Filters
     */
    case "FILTER_ADD_CATEGORY":
      return {
        ...state,
        filterCategories: [...state.filterCategories, action.payload]
      };
    case "FILTER_REMOVE_CATEGORY":
      return {
        ...state,
        filterCategories: action.payload
      };

    case "FILTER_ADD_SUBCATEGORY":
      return {
        ...state,
        filterSubCategories: [...state.filterSubCategories, action.payload]
      };
    case "FILTER_REMOVE_SUBCATEGORY":
      return {
        ...state,
        filterSubCategories: action.payload
      };
    case "FILTER_ADD_PARAMS":
      return {
        ...state,
        filterParams: [...state.filterParams, action.payload]
      };
    case "FILTER_REMOVE_PARAMS":
      return {
        ...state,
        filterParams: action.payload
      };
    case "FILTER_ISIN":
      return {
        ...state,
        filterIsin: action.payload
      };
    /**
     * Store compare
     */
    case "ADD_COMPARE":
      return {
        ...state,
        dataCompare: action.payload
      };
    case "REMOVE_COMPARE":
      return {
        ...state,
        dataCompare: action.payload
      };
    case "DETAIL_PAGE":
      return {
        ...state,
        detail_page: action.payload
      };
    /**
     * Store Favs
     */
    case "IS_LOADING":
      return {
        ...state,
        loading: action.payload
      };
    /**
     * Store Favs
     */
    case "RAZ_FAV":
      return {
        ...state,
        favs: []
      };
    case "ADD_FAV":
      return {
        ...state,
        favs: [...state.favs, action.payload]
      };
    case "REMOVE_FAV":
      return {
        ...state,
        favs: action.payload
      };
    case "SHOW1COL":
      return {
        ...state,
        showCol1Yperf: action.payload
      };
    case "SHOW3COL":
      return {
        ...state,
        showCol3Yperf: action.payload
      };
    case "SEARCH":
      return {
        ...state,
        searchPattern: action.payload
      };
    default:
      return state;
  }
}

export function StoreProvider(props: any) {
  const [state, dispatch] = React.useReducer(reducer, {
    /** */
    loading: false,
    /** */
    dataCompare: false,
    /** */
    tableDisplay: true,
    tableResults: [],
    tableTotal: {
      value: 0
    },
    detail_page: {
      show: false,
      content: null
    },
    showCol1Yperf: false,
    showCol3Yperf: true,
    /** */
    favs: [],
    /** */
    tableTaxo: {},
    /** */
    filterSize: 100,
    filterCurrentPage: 1,
    filterCurrentSize: 0,
    filterCategories: [],
    filterSubCategories: [],
    filterParams: [],
    filterIsin: "",
    searchPattern: ""
  });

  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
